"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.getMessageCode = function getMessageCode(messages, code) {
    if (!messages || typeof messages !== 'object')
        return undefined;
    if (messages.get && typeof messages.get === 'function') {
        return messages.get(code);
    }
    return messages[code];
};
exports.getMessage = function getMessage(messages, code, args) {
    var message = exports.getMessageCode(messages, code);
    if (args && message) {
        for (var i in args) {
            if (args.hasOwnProperty(i)) {
                var find = "\\{" + i + "\\}";
                var re = new RegExp(find, 'g');
                message = message.replace(re, "" + args[i]);
            }
        }
    }
    return message;
};
exports.getMessageJsx = function getMessageJsx(messages, code, args) {
    var message = exports.getMessageCode(messages, code);
    if (!args || !message)
        return message;
    var messageParts = message.split(/{(\d*)}/);
    return messageParts.map(function (val, i) {
        if (i % 2 === 0)
            return val;
        var replacement = args[val];
        if (!replacement)
            return "{" + val + "}";
        if (react_1.default.isValidElement(replacement)) {
            replacement = react_1.default.cloneElement(replacement, { key: val });
        }
        return replacement;
    });
};
//# sourceMappingURL=data:application/json;base64,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